/**
 * D6 — Phone-number masking helpers with role-gated full visibility.
 *
 * RBAC: business_user + supervisor see masked; developer + administrator
 * + owner can call ``canViewFullRecipientNumber(role)`` → true and
 * unmask via ``UnmaskToggle``.
 *
 * Masking format: last-4 visible (``••••1234``). Preserves country-
 * code prefix for recognition (``+1•••1234`` when stripped of middle
 * digits — but for v3 we just show last-4 since the API masks
 * tenant-scoped phones the same way).
 */

const ELEVATED_ROLES = new Set(["developer", "administrator", "owner"]);

export function canViewFullRecipientNumber(role) {
  return ELEVATED_ROLES.has(role);
}

export function maskPhone(e164) {
  if (!e164 || typeof e164 !== "string") return "••••";
  const trimmed = e164.replace(/\s+/g, "");
  if (trimmed.length < 4) return "••••";
  return `••••${trimmed.slice(-4)}`;
}

export function formatPhone(e164, { mask = false, role = null } = {}) {
  if (mask || (role && !canViewFullRecipientNumber(role))) {
    return maskPhone(e164);
  }
  // Light formatting for E.164 (US-style grouping for +1)
  if (!e164) return "—";
  if (e164.startsWith("+1") && e164.length === 12) {
    const d = e164.slice(2);
    return `+1 (${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
  }
  return e164;
}
